export function calculateTotalPages(results, chunk = 12) {
  // floor because we dont fetch the rest if they are below the chunk of 12
  // || to show at least 1 page (no zero)
  const totalPages = Math.floor(results / chunk) || 1
  return totalPages
}

export const capitalizeFirstLetter = (
  [first, ...rest],
  locale = navigator.language
) => first.toLocaleUpperCase(locale) + rest.join('')
